import {
	dispatchAcknowledgedEvent,
	openResourceSection,
} from '../../core/resourceEvents';
import {
	SNMP_CONFIGURATION_FILTER_EVENT,
	SNMP_CONFIGURATION_FOCUS_EVENT,
	SNMP_CONFIGURATION_SECTION_EVENT,
} from './events';

const SECTIONS = new Set(['profile.snmp_profiles']);

/**
 * Open the SNMP accordion on the Templates page.
 * @return {Promise<void>} completion acknowledgement
 */
export function openSnmpConfigurationSection() {
	return openResourceSection(
		SNMP_CONFIGURATION_SECTION_EVENT,
		'profile.snmp_profiles',
		SECTIONS,
	);
}

/**
 * Filter the SNMP table to a search term.
 * @param {string} query search text
 * @return {Promise<void>} acknowledgement
 */
export function applySnmpConfigurationFilter(query) {
	return dispatchAcknowledgedEvent(SNMP_CONFIGURATION_FILTER_EVENT, {
		query: String(query || '').trim(),
		resource: 'snmp_configuration',
	});
}

/**
 * Point at one SNMP row in the table.
 * @param {string} entityId profile identifier
 * @return {Promise<void>} acknowledgement
 */
export function focusSnmpConfiguration(entityId) {
	if (!entityId) return Promise.reject(new Error('invalid_snmp_configuration_focus'));
	return dispatchAcknowledgedEvent(SNMP_CONFIGURATION_FOCUS_EVENT, {
		entityId: String(entityId),
		resource: 'snmp_configuration',
	});
}
